import { cn } from '@/utils';
import React from 'react';

interface NoShowsDonutProps {
  rate: number;
  isHighRate: boolean;
}

export const NoShowsDonut: React.FC<NoShowsDonutProps> = ({
  rate,
  isHighRate,
}) => {
  const radius = 70;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (rate / 100) * circumference;

  return (
    <div className='relative w-44 h-44 animate-in fade-in zoom-in duration-700'>
      <svg className='w-full h-full transform -rotate-90'>
        <circle
          cx='88'
          cy='88'
          r={radius}
          stroke='#f1f5f9'
          strokeWidth='12'
          fill='none'
        />
        <circle
          cx='88'
          cy='88'
          r={radius}
          stroke={isHighRate ? '#ef4444' : '#10b981'}
          strokeWidth='12'
          fill='none'
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap='round'
          className='transition-all duration-1000 ease-out'
        />
      </svg>

      <div className='absolute inset-0 flex flex-col items-center justify-center'>
        <span
          className={cn(
            'text-5xl font-[1000] tracking-tighter mb-1',
            isHighRate ? 'text-red-600' : 'text-emerald-600'
          )}
        >
          {rate.toFixed(1)}%
        </span>
        <span className='text-[10px] text-slate-400 font-black uppercase tracking-[0.2em]'>
          Ausentismo
        </span>
      </div>
    </div>
  );
};
